import {IconButton} from '@dropbox/dig-components/buttons';
import {Tooltip} from '@dropbox/dig-components/tooltips';
import {UIIcon} from '@dropbox/dig-icons';
import {AddLine} from '@dropbox/dig-icons/assets';
import {ROUTE_PATHS} from 'constant';
import {t} from 'i18next';
import {useNavigate} from 'react-router';

/**
 * The Teams header's create button, like Workstreams'. Opens the new-team form
 * with the open team as the parent (changeable there).
 */
export const NewTeamButton = ({parentSlug}: {parentSlug?: string}) => {
  const navigate = useNavigate();

  return (
    <Tooltip title={t('new_team')}>
      <IconButton
        variant="transparent"
        size="small"
        aria-label={t('new_team')}
        onClick={() =>
          navigate(
            parentSlug
              ? `${ROUTE_PATHS.TEAM_NEW}?parent=${encodeURIComponent(parentSlug)}`
              : ROUTE_PATHS.TEAM_NEW
          )
        }
      >
        <UIIcon src={AddLine} />
      </IconButton>
    </Tooltip>
  );
};
